import React from "react";

const MutedText = ({ as: Component = "div", className = "", children, ...props }) => {
  return (
    <Component className={`text-xs panel-text-helper ${className}`.trim()} {...props}>
      {children}
    </Component>
  );
};

export default MutedText;
